jQuery(document).ready(function() {

/*jQuery(document).on('click','.cart__checkout-button',function(e){ 
  e.preventDefault();
  var myModal =$('#myModal');
    $.ajax({
      type: 'POST',
      url: '/cart',
      dataType: 'json', 
      success: function (data) { 
       console.log(data);
        var checkout_url = `/checkouts/c/${data.token}/information`;
        if(getCookie('popupCookie') != 'submited_yes'){
           myModal.addClass('in');
           myModal.css('display','block');
        }else{
           window.location.href = checkout_url;
        }
         $(document).on('click','.btn-success',function(){
           myModal.removeClass('in');
           myModal.css('display','none');
          setCookie( 'popupCookie', 'submited_yes', 2 );
          window.location.href = checkout_url;
        });
         $(document).on('click','.btn-danger',function(){
            window.location = "https://www.google.com/";
         })
         //console.log(checkout_url);
        //window.location.href = checkout_url;
      } 
    })  
 });*/

// =========================age gate for buy now button============================//
// const shopify_payment_button = document.querySelectorAll(".shopify-payment-button");
// if(shopify_payment_button.length > 0){
// for (let i = 0; i < shopify_payment_button.length; i++) {
// shopify_payment_button[i].addEventListener('click', function(e) {
//     e.preventDefault();
//     e.stopPropagation();
//     var myModal =$('#myModal');
//     var variant_id = $('form[action="/cart/add"]').find('input[name="id"]').val();
//     var quantity   = $('input[name="quantity"]').val();
//     var buy_now_checkout_url = `/cart/${variant_id}:${quantity}`;
//     console.log('buy_now_checkout_url :'+buy_now_checkout_url)
//     if(getCookie('popupCookie') != 'submited_yes'){
//            myModal.addClass('in');
//            myModal.css('display','block');
//     }else{
//            window.location.href = buy_now_checkout_url;
//     }
//      $(document).on('click','.btn-success',function(){
//            myModal.removeClass('in');
//            myModal.css('display','none');
//           setCookie( 'popupCookie', 'submited_yes', 2 );
//           window.location.href = buy_now_checkout_url;
//       });
//      $(document).on('click','.btn-danger',function(){
//             window.location = "https://www.google.com/";
//      })
//     // do stuff
//       }, true)
// }
// }
// =========================end age gate for buy now button============================//
  // if(getCookie('popupCookie') != 'submited_yes'){ 
  //       myModal.addClass('in');
  //       myModal.css('display','block');
  //   }
  //  $(document).on('click','.btn-success',function(){
  //    myModal.removeClass('in');
  //    myModal.css('display','none');
  //   setCookie( 'popupCookie', 'submited_yes', 2 );
  // });

 


  
   
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }



  
  });